import React from 'react';
import { Tabs } from '@raisin/components-lib';

import { DBSProduct } from 'types';
import { OfferDetailTab } from './types';
import BankOffersDetailTabPanel from './BankOffersDetailTabPanel';

export interface BankOffersDetailTabsProps {
  tabs: OfferDetailTab[];
  offer: DBSProduct;
}

export const BankOffersDetailTabs: React.FC<BankOffersDetailTabsProps> = ({ tabs, offer }) => {
  const tabsConfig = tabs.map((t) => ({
    label: t.title,
    id: t.id,
    content: <BankOffersDetailTabPanel fields={t.fields} offer={offer} tabId={t.id} />,
  }));

  return <Tabs tabs={tabsConfig} />;
};

export default BankOffersDetailTabs;
